import { FC, useContext } from 'react';
import { DateTime } from 'luxon';
import { context as DependencyContext } from '../context/dependency';
import { context as StateContext } from '../context/state';
import _CustomReportToolBar from '../component/compound/CustomReportToolBar';

type Props = { className?: string };

const CustomReportToolBar: FC<Props> = ({ className }) => {
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);

  return (
    <_CustomReportToolBar
      onSelectFromPeriod={(date: DateTime | null) => {
        dependency.customReportUsecase.setFromPeriod(date);
      }}
      onSelectToPeriod={(date: DateTime | null) => {
        dependency.customReportUsecase.setToPeriod(date);
      }}
      customReportChartPeriod={state.customReportChartSetting.period}
      customReport={state.customReport.data}
      customReportLoading={state.customReport.fetching > 0 || state.lastAccessedOrganization.fetching > 0}
      selectedChartGroup={state.selectedChartGroup.data}
      setSelectedChartGroup={dependency.customReportUsecase.setSelectedChartGroup}
      className={className}
    />
  );
};

export default CustomReportToolBar;
